import actionTypes from './actionTypes';

export default {
  [actionTypes.CART_LOAD_START]: (tenant, shopperId) => ({
    type: actionTypes.CART_LOAD_START,
    tenant,
    shopperId,
  }),
  [actionTypes.CART_LOAD_SUCCESS]: (cart, tenant, shopperId, locale) => ({
    type: actionTypes.CART_LOAD_SUCCESS,
    cart,
    tenant,
    shopperId,
    locale,
  }),
  [actionTypes.CART_LOAD_FAIL]: (error, tenant, shopperId) => ({
    type: actionTypes.CART_LOAD_FAIL,
    error,
    tenant,
    shopperId,
  }),
  [actionTypes.CART_CLEAR]: () => ({
    type: actionTypes.CART_CLEAR,
  }),
  [actionTypes.CART_CHANGED_EXTERNALLY]: () => ({
    type: actionTypes.CART_CHANGED_EXTERNALLY,
  }),
  [actionTypes.INCREMENT_PENDING_OPERATION_RELOAD_ATTEMPTS]: () => ({
    type: actionTypes.INCREMENT_PENDING_OPERATION_RELOAD_ATTEMPTS,
  }),
  [actionTypes.RESET_PENDING_OPERATION_RELOAD_ATTEMPTS]: () => ({
    type: actionTypes.RESET_PENDING_OPERATION_RELOAD_ATTEMPTS,
  }),
};
